// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgPajamas = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="293 206 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.cls-1,
.cls-2 {
  fill: #fff;
}

.cls-3 {
  stroke: none;
}

.cls-2 {
  stroke-miterlimit: 10;
}

.cls-3,
.cls-4 {
  fill: var(--mascot-accent, #ff49a4);
}

.cls-5 {
  fill: #f39ee5;
}

.cls-2 {
  stroke: #000;
  stroke-width: 0.5px;
}

.cls-6 {
  fill: #e0cae3;
}

.cls-4 {
  opacity: 0.4;
}
`}</style>
    </defs>
    <path
      className="cls-1"
      d="M508.62,311.6c0,35.48-17.52,66.86-44.39,85.97-14.93,10.62-32.74,17.45-52.03,19.07-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-28.69-18.83-47.64-51.3-47.64-88.19,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="cls-4"
      d="M508.62,311.6c0,35.48-17.52,66.86-44.39,85.97-14.93,10.62-32.74,17.45-52.03,19.07-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-28.69-18.83-47.64-51.3-47.64-88.19,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M483.29,364.8c.6-1.93-6.92-11.34-12.13-17.71-5.21-6.35-10.8-13.34-16.45-18.81-2.31-2.25-5.68-5.31-8.82-8.12-.69-.65-1.37-1.25-2.02-1.84-2.18-1.93-4.08-3.61-5.27-4.65-.79-.7-1.25-1.1-1.25-1.1,0,0-1.44,12.66-.73,18.28.02.18.04.33.08.49.77,5.59,3.01,13.04,7.24,18.12.73.87,1.47,1.67,2.26,2.42.47.44.95.89,1.44,1.31.46.4.99.8,1.54,1.23.72.57,1.45,1.11,2.19,1.65.11.07.22.16.33.25.3.21.57.42.87.63,1.64,1.15,3.29,2.32,4.98,3.67.25.18.48.38.72.57.28.25.54.47.8.69,5.4,4.69,13.02,12.06,14.99,11.37,1.98-.71,8.64-6.52,9.23-8.46Z" />
    <path d="M327.18,364.8c-.6-1.93,6.92-11.34,12.13-17.71,5.21-6.35,10.8-13.34,16.45-18.81,2.31-2.25,5.68-5.31,8.82-8.12.69-.65,1.37-1.25,2.02-1.84,2.18-1.93,4.08-3.61,5.27-4.65.79-.7,1.25-1.1,1.25-1.1,0,0,1.44,12.66.73,18.28-.02.18-.04.33-.08.49-.77,5.59-3.01,13.04-7.24,18.12-.73.87-1.47,1.67-2.26,2.42-.47.44-.95.89-1.44,1.31-.46.4-.99.8-1.54,1.23-.72.57-1.45,1.11-2.19,1.65-.11.07-.22.16-.33.25-.3.21-.57.42-.87.63-1.64,1.15-3.29,2.32-4.98,3.67-.25.18-.48.38-.72.57-.28.25-.54.47-.8.69-5.4,4.69-13.02,12.06-14.99,11.37-1.98-.71-8.64-6.52-9.23-8.46Z" />
    <path
      className="cls-3"
      d="M330.64,357.83c-1.13-2.42,5.97-12.02,10.93-18.49,4.96-6.44,10-11.95,16.27-16.54,4.99-3.65,6.97-4.65,9.99-6.34.82-.46,3.25-1.47,3.91-2.02,2.23-1.83,4.17-3.43,5.39-4.41.81-.66,1.27-1.05,1.27-1.05,0,0,1.17,11.83,1.5,18.36.01.21.02.38.01.57.24,6.48-.89,14.87-4.92,20.02-.7.88-1.43,1.68-2.22,2.4-.47.42-.96.86-1.47,1.25-.47.38-1.03.75-1.61,1.14-.75.53-1.52,1.01-2.3,1.5-.12.05-.24.14-.35.22-.32.19-.6.38-.92.56-1.73,1.02-3.49,2.06-5.24,3.31-.26.16-.5.35-.75.53-.29.23-.56.44-.83.65-5.55,4.43-13.2,11.59-15.73,10.35-2.55-1.26-11.83-9.58-12.95-12.01Z"
    />
    <path
      className="cls-3"
      d="M479.95,357.83c1.13-2.42-5.97-12.02-10.93-18.49-4.96-6.44-10-11.95-16.27-16.54-4.99-3.65-6.97-4.65-9.99-6.34-.82-.46-3.25-1.47-3.91-2.02-2.23-1.83-4.17-3.43-5.39-4.41-.81-.66-1.27-1.05-1.27-1.05,0,0-1.17,11.83-1.5,18.36-.01.21-.02.38-.01.57-.24,6.48.89,14.87,4.92,20.02.7.88,1.43,1.68,2.22,2.4.47.42.96.86,1.47,1.25.47.38,1.03.75,1.61,1.14.75.53,1.52,1.01,2.3,1.5.12.05.24.14.35.22.32.19.6.38.92.56,1.73,1.02,3.49,2.06,5.24,3.31.26.16.5.35.75.53.29.23.56.44.83.65,5.55,4.43,13.2,11.59,15.73,10.35,2.55-1.26,11.83-9.58,12.95-12.01Z"
    />
    <ellipse className="cls-3" cx={404.79} cy={284.67} rx={46.68} ry={51.57} />
    <path
      className="cls-3"
      d="M464.23,396.51c-14.93,10.62-32.74,17.45-52.03,19.07-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.44-6.1-.11-12.43,1.13-18.9.88-4.56,1.85-9.06,2.94-13.47.41-1.66.83-3.31,1.27-4.94.9-3.38,1.88-6.69,2.92-9.92,4.18-13.01,9.48-24.67,16.08-33.82,1.06-1.49,2.16-2.9,3.3-4.25.08-.1.17-.2.25-.29,1.47-1.72,2.99-3.32,4.58-4.79h.01c7.6-7.08,16.57-11.19,27.07-11.19s19.52,3.93,27.23,10.78c1.73,1.53,3.39,3.21,4.99,5.03.32.37.64.74.95,1.12.78.92,1.53,1.87,2.27,2.86,6.68,8.9,12.04,20.34,16.14,33.32,1.14,3.59,2.18,7.29,3.12,11.09h0c.39,1.58.76,3.15,1.11,4.75h0c1,4.48,1.87,9.05,2.62,13.72.91,5.69,1.16,11.27.84,16.68Z"
    />
    <path
      className="cls-6"
      d="M412.2,416.64c-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-18.09-4.15-35.08-25.89-30.29-50.82,1.01-5.24,2.23-10.38,3.7-15.24.24-.82.49-1.62.75-2.42,1.92-5.99,4.23-11.53,6.96-16.31.54-.94,1.09-1.85,1.66-2.73h.01c.03-.07.08-.14.12-.2,5.86-8.97,13.48-14.65,23.23-14.65s17.66,5.55,23.63,14.52c.25.38.5.76.74,1.15.51.8,1,1.62,1.48,2.47h0c2.47,4.43,4.58,9.48,6.31,14.98.28.89.55,1.79.81,2.7,1.44,4.96,2.58,10.25,3.46,15.73,3.92,24.58-11.64,45.76-29.13,50.53Z"
    />
    <path d="M441.67,306.29s.07-.01.07-.01c-4.93,15.54-15.53,25.68-18.88,36.82-4.47,14.84-5.82,30.11-7.09,31.49-2.54,2.73-17.77,2.73-21.15,0-1.7-1.38-1.18-15.86-6.24-29.04-5.75-14.94-6.57-17.17-13.96-28.63.01-.03.03-.07.07-.1-4.47-6.81-10.75-19.47-10.75-30.98,0-25.75,18.39-46.63,41.05-46.63s41.05,20.88,41.05,46.63c0,7.35-1.5,14.29-4.17,20.46Z" />
    <g>
      <path
        className="cls-5"
        d="M373.73,300.88c1.32-.55,2.21-1.09,2.75-2.41.53-1.32.27-2.32-.3-3.63-.57-1.31-1.99-2.52-3.2-3.04-1.21-.52-2.06-.71-3.36-.47-1.3.24-3.33,1.52-3.82,2.85-.49,1.33-.27,2.32.3,3.63.57,1.31,1.6,2.39,3.2,3.04,1.6.64,3.1.57,4.43.02Z"
      />
      <path
        className="cls-5"
        d="M435.57,300.83c-1.33-.52-2.23-1.04-2.8-2.35-.56-1.31-.32-2.32.23-3.63.55-1.32,1.94-2.55,3.14-3.1,1.2-.55,2.04-.75,3.35-.54,1.31.21,3.36,1.45,3.87,2.78.51,1.33.32,2.32-.23,3.64-.55,1.32-1.55,2.42-3.14,3.1-1.59.67-3.09.63-4.43.11Z"
      />
    </g>
    <path
      className="cls-3"
      d="M377.88,241.56c-4.75,3.9-9.21,8.7-12.4,14.3-4.15-1.99-8.44-4.73-9.05-7.62-1.13-5.33,1.18-10.89,4.55-13.17,3.37-2.27,6.38-2.37,10.33-1.36,1.93.48,4.48,4.2,6.58,7.85Z"
    />
    <path
      className="cls-3"
      d="M453.16,248.23c-.61,2.89-5.49,5.63-9.64,7.62-3.19-5.6-6.87-9.38-11.62-13.28,2.09-3.65,4.46-8.39,6.39-8.87,3.95-1.01,6.96-.91,10.33,1.36,3.37,2.27,5.68,7.84,4.55,13.17Z"
    />
    <path
      className="cls-2"
      d="M379.43,279.44c.09-5.51-4.33-10.05-9.86-10.14-5.53-.09-10.09,4.31-10.17,9.83-.09,5.51,4.33,10.05,9.86,10.14,5.53.09,10.09-4.31,10.17-9.83Z"
    />
    <path d="M370.37,287.66c4.52.7,8.36-3.12,7.67-7.62-.43-2.8-2.72-5.09-5.53-5.52-4.52-.7-8.36,3.12-7.67,7.62.43,2.8,2.72,5.09,5.53,5.52Z" />
    <path
      className="cls-2"
      d="M449.56,279.44c.09-5.51-4.33-10.05-9.86-10.14-5.53-.09-10.09,4.31-10.17,9.83-.09,5.51,4.33,10.05,9.86,10.14,5.53.09,10.09-4.31,10.18-9.83Z"
    />
    <path d="M436.44,287.3c4.52.7,8.36-3.12,7.67-7.63-.43-2.8-2.73-5.09-5.53-5.52-4.52-.7-8.36,3.12-7.67,7.63.43,2.8,2.73,5.09,5.53,5.52Z" />
  </svg>
);
export { SvgPajamas };
